import axios from 'axios';
const BASE_URL = process.env.REACT_APP_BASE_URL;
const instance = axios.create({
    baseURL: BASE_URL
});
//instance.defaults.headers.common['Authorization'] = '';
//instance.interceptors.request...
export default instance;
